const choices = {
    caseManager: "Chargé d'Affaire",
    cgp: 'Conseiller en Gestion de Patrimoine',
    cdd: 'Chargé de Développement',
    dcr: 'CGP - Délegué(e) commercial(e)',
};

export default choices;
